import React from "react";

const Blogs = () => {
  return (
    <div className="min-h-screen w-full flex justify-center items-center">
      <h2 className="text-3xl font-semibold text-secondary -mt-32">
        Coming Soon ...{" "}
      </h2>
    </div>
  );
};

export default Blogs;
